import { render, staticRenderFns } from "./customersRefund.vue?vue&type=template&id=3b5d30b0&"
import script from "./customersRefund.vue?vue&type=script&lang=js&"
export * from "./customersRefund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports